const Unauthorized = () => (
  <div className="mt-5 p-5 text-center">
    <h3 className="m-0 fw-bold themeBlue">🚫 Access Denied</h3>
    <p className="themeBlue">You don’t have permission to view this page.</p>
  </div>
);

export default Unauthorized;